/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';

import Text from './Text';
import BoxButton from './BoxButton';
import Newsletter from './Newsletter';

import styles from '../../../styles/partials/footer.scss';

const propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    contactLink: PropTypes.string,
};

const defaultProps = {
    contactLink: null,
};

const Footer = ({ intl, contactLink }) => (
    <div className={styles.container}>
        <div className={styles.inner}>
            <div className={styles.cols}>
                <div
                    className={classNames({
                        [styles.col]: true,
                        [styles.colAddress]: true,
                    })}
                >
                    <div className={styles.inner}>
                        <div className={styles.address}>
                            <Text>
                                {intl.formatMessage({
                                    id: 'content.address',
                                    defaultMessage:
                                        '210b ave Mozart west\nMontreal, QC\nH2S 1C4\nCANADA',
                                })}
                            </Text>
                        </div>
                        <div className={styles.social}>
                            <a
                                href="https://twitter.com/catbirdprod"
                                target="_blank"
                                className={styles.item}
                            >
                                <span
                                    className={classNames({
                                        [styles.icon]: true,
                                        [styles.twitter]: true,
                                    })}
                                />
                            </a>
                            <a
                                href="https://www.facebook.com/CatbirdProductions"
                                target="_blank"
                                className={styles.item}
                            >
                                <span
                                    className={classNames({
                                        [styles.icon]: true,
                                        [styles.facebook]: true,
                                    })}
                                />
                            </a>
                            <a
                                href="https://vimeo.com/catbird"
                                target="_blank"
                                className={styles.item}
                            >
                                <span
                                    className={classNames({
                                        [styles.icon]: true,
                                        [styles.vimeo]: true,
                                    })}
                                />
                            </a>
                        </div>
                    </div>
                    <div className={styles.inner}>
                        <div className={styles.text}>
                            <strong>T: </strong>
                            <FormattedMessage id="content.phone" defaultMessage="+1.514.419.8590" />
                        </div>
                        <BoxButton
                            label={{
                                id: 'content.contact_us',
                                defaultMessage: 'Contact us',
                            }}
                            link={contactLink}
                            small
                        />
                    </div>
                </div>
                <div
                    className={classNames({
                        [styles.col]: true,
                        [styles.colMailingList]: true,
                    })}
                >
                    <div className={styles.inner}>
                        <div className={styles.text}>
                            <strong>
                                <FormattedMessage
                                    id="content.mailing_list"
                                    defaultMessage="Mailing list. "
                                />
                            </strong>
                            <FormattedMessage
                                id="content.keep_in_touch"
                                defaultMessage="Let’s keep in touch..."
                            />
                        </div>
                        <div className={styles.newsletter}>
                            <Newsletter />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./js/components/partials/Footer.jsx